<style lang="scss" scoped>
:host {
  min-height: 100vh;
  background-color: #f6f6f6;
}
.onsale-container {
  .filter-container {
    height: 90px;
    width: 100%;
    padding: 0 24px;
    position: fixed;
    z-index: 10;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    .sum-sort, .price-sort, .date-sort {
      font-size: 28px;
      color: #999;
      margin-right: 48px;
      .price-icon {
        height: 24px;
        width: 12px;
        margin-top: -4px;
      }
      &.selected {
        color: #1d1d1d;
      }
    }
    .filter-btn {
      font-size: 28px;
      color: #1d1d1d;
      flex: 1;
      text-align: right;
      .filter-icon {
        height: 24px;
        width: 24px;
        margin-top: -4px;
      }
    }

  }

  .pd-list {
    width: 702px;
    margin: 114px auto 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .pd-item {
      width: 342px;
      height: 554px;
      margin-bottom: 24px;
      background-color: #ffffff;
      overflow: hidden;
      .pd-pic-container {
        width: 342px;
        height: 342px;
        position: relative;
        .pic-container {
          height: 342px;
          width: 342px;
          border: 2px solid #eee;
          box-sizing: border-box;
          overflow: hidden;
          img {
            height: 100%;
            width: 100%;
            object-fit: contain;
          }
        }
          .grade {
            position: absolute;
            left: 0;
            top: 0;
            height: 28px;
            line-height: 28px;
            padding: 0 8px;
            color: #ffffff;
            // font-style: italic;
            font-size: 18px;
            // font-weight: bold;
            background: #FFB6B6;
          }
        // img {
        //   height: 100%;
        //   width: 100%;
        //   object-fit: contain;
        // }
        .apprasial-label {
          position: absolute;
          right: 0;
          top: 0;
          height: 28px;
          line-height: 28px;
          padding: 0 5px;
          color: #ffffff;
          font-style: italic;
          font-size: 18px;
          font-weight: bold;
          background: linear-gradient(#835dfd, #8f8af5);
        }
        .seckill-label {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 40px;
          line-height: 40px;
          color: #ffffff;
          background: linear-gradient(270deg, #ff3155, #ff5a1f);
          font-size: 22px;
          font-weight: bold;
          text-align: center;
        }
      }
      .brand {
        height: 36px;
        line-height: 36px;
        font-size: 28px;
        color: #1d1d1d;
        margin-top: 20px;
        padding-left: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .officical-icon {
            display: inline-block;
            position: relative;
            top: -4px;
            color: #ffffff;
            font-size: 18px;
            line-height: 28px;
            // @include txts(18px, #ffffff, 28px);
            min-width: 48px;
            padding: 0 5px;
            text-align: center;
            background: #8DB7EE;
            margin-right: 8px;
            background-image: linear-gradient(-42deg, #5B86FF 0%, #A1DAFF 100%);
        }
      }
      .brand-container {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 40px;
        padding-left: 16px;
        .grade {
          display: inline-block;
          height: 28px;
          font-size: 18px;
          color: #8ab1e9;
          line-height: 28px;
          padding: 0 4px;
          box-sizing: border-box;
          border: 1px solid #8ab1e9;
          border-radius: 2px;
          margin: 10px 4px 0 0;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .brand-name {
          line-height: 40px;
          font-size: 28px;
          color: #666;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          height: 40px;
        }
      }
      .to-seckill-price {
        padding-left: 16px;
        margin-top: 8px;
        margin-bottom: 8px;
        height: 40px;
        span {
          display: inline-block;
          height: 40px;
          line-height: 40px;
          box-sizing: border-box;
          border: 2px solid #fc4655;
          background-color: #ffffff;
          padding: 0 10px;
          color: #fc4655;
          font-size: 22px;
          // font-weight: bold;
        }
      }
        .seckill-price {
          margin-top: 10px;
          padding-left: 16px;
          position:relative;
          left: -8px;
          .price {
            padding: 0 4px;
            color: #2d2d2d;
            font-size: 34px;
            height: 48px;
            line-height: 40px;
            &.seckill {
              color: #fc4655;
            }
          }
          .official-price {
            color: #999999;
            font-size: 24px;
            margin-top: 10px;
            text-decoration-line: line-through;
          }
          .note-label {
            position: relative;
            display: inline-block;
            height: 36px;
            padding: 0 6px;
            line-height: 36px;
            color: #fc4655;
            box-sizing: border-box;
            border: 1px solid #fc4655;
            font-size: 20px; 
            margin-left: 10px;
            &::before {
              content: '';
              position: absolute;
              left: -10px;
              top: 10px;
              display: block;
              width: 10px;
              height: 10px;
              box-sizing: border-box;
              border: 5px solid transparent;
              border-right: 5px solid #fc4655;
            }
            &::after {
              content: '';
              position: absolute;
              left: -8px;
              top: 11px;
              display: block;
              width: 8px;
              height: 8px;
              box-sizing: border-box;
              border: 4px solid transparent;
              border-right: 4px solid #ffffff;
            }
          }
        }
      .apprasial-label {
        margin-left: 16px;
        height: 28px;
        line-height: 22px;
        padding: 0 6px;
        color: #ffffff;
        font-style: italic;
        font-size: 14px;
        font-weight: bold;
        display: inline-block;
        margin-right: 4px;
        .a-icon {
          height: 28px;
          width: 92px;
        }
      }
      .seckill-label {
        height: 28px;
        line-height: 22px;
        padding: 0 6px;
        color: #FC4655;
        font-size: 14px;
        font-weight: bold;
        display: inline-block;
        margin-left: 16px;
        .s-icon {
          height: 28px;
          width: 48px;
        }
      }
      .normal-price {
        // margin-top: 10px;
        padding-left: 16px;
          color: #030601;
          font-size: 34px;
          height: 40px;
          line-height: 40px;
          font-weight: bold;
      }
      .official-price {
        color: #999999;
        padding-left: 16px;
        font-size: 24px;
        // margin-top: 10px;
        text-decoration-line: line-through;
      }
    }
    
  }

  .filter-pannel {
    width: 570px;
    height: 100vh;
    background-color: #ffffff;
    padding-left: 32px;
    box-sizing: border-box;
    padding: 60px 0 166px 32px;
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    .split-line {
      height: 2px;
      width: 100%;
      margin: 32px 0;
      background-color: #f7f7f7;
    }
    .title {
      color: #1D1D1D;
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 16px;
    }
    .price-container {
      .price-input {
        width: 45%;
        height: 56rpx;
        box-sizing: border-box;
        line-height: 56px;
        border: 2px solid #F7F7F7;
        font-size: 26px;
        color: #A3A3A3;
        border-radius: 30px;
        text-align: center;
        background-color: #f7f7f7;
        color: #1D1D1D;
      }
      .price-to {
        margin: 0 14px;
      }
    }
    .newdegree-container, .size-container {
      .operate-container {
        display: flex;
        box-sizing: border-box;
        flex-wrap: wrap;
        .newdegree-item, .size-item {
          margin-right: 24px;
          margin-bottom: 16px;
          display: inline-block;
          padding: 16px 20px;
          box-sizing: border-box;
          font-size: 26px;
          position: relative;
          border-radius: 4px;
          color: #999;
          background: #F7F7F7;
          border: 2px solid #F7F7F7;
          &.selected {
            color: #8AB1E9;
            background: #fff;
            border: 2px solid #8AB1E9;
          }
        }
      }
    }
    .color-container {
      .operate-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        .color-item {
          width: 56px;
          height: 56px;
          margin-right: 28px;
          margin-bottom: 28px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          border: 2px solid #dedede;
          &.selected {
            border: 2px solid #1d1d1d;
          }
          .color-item-inner {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            box-sizing: border-box;
          }
        }
      }
    }
    .button-container {
      position: fixed;
      width: 570px;
      bottom: 0;
      left: 0;
      padding-bottom: 68px;
      display: flex;
      align-items: center;
      background: #fff;
      .cancel-btn {
        width: 35%;
        height: 98px;
        background-color: #eee;
        color: #1d1d1d;
        font-size: 34px;
        line-height: 98px;
        text-align: center;

      }
      .confirm-btn {
        flex: 1;
        height: 98px;
        background-color: #8fa9ce;
        color: #fff;
        font-size: 34px;
        text-align: center;
        line-height: 98px;
      }

    }
  }

}
.empty-err-page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  height: calc(100vh - 0px);
  width: 100vw;
  // background-color: white;
  padding-top: 360px;
  box-sizing: border-box;
  max-height: 100%;
  .status-icon {
    width: 180px;
    height: 100px;
    margin-bottom: 48px;
    object-fit: contain;
  }
  .status-text {
    color: #333;
    font-size: 30px;
    line-height: 42px;
  }
  .status-link {
    color: #999;
    margin-top: 28px;
    font-size: 24px;
    line-height: 34px;
    text-decoration: underline;
  }
  .tips {
    color: #999;
    margin-top: 28px;
    font-size: 24px;
    line-height: 34px;
  }
}
</style>

<template>
  <div class="onsale-container">
    <div class="filter-container">
      <div :class="'sum-sort ' + (sortType==='-recommendation_score' ? 'selected' : '')" @click="changeSortType('-recommendation_score')">综合排序</div>
      <div :class="'price-sort ' + (sortType.indexOf('actual_price') >= 0 ? 'selected' : '')" @click="changeSortType('+actual_price')">价格
        <img class="price-icon" :src="sortType === '+actual_price' ? priceUpUrl : (sortType === '-actual_price' ? priceDownUrl : priceGreyUrl)">
      </div>
      <div :class="'date-sort ' + (sortType==='-create_time' ? 'selected' : '')" @click="changeSortType('-create_time')">最新上架</div>
      <div class="filter-btn">
        <span @click="changeFilterShow()">
          筛选
        <img class="filter-icon" src="https://oss.turingsenseai.com/1595988535967923779.png">
        </span>
      </div>
      
    </div>
    <div v-if="errStatus == 1" class="empty-err-page-container">
      <!-- 网络异常情况 -->
      <img class="status-icon" src="https://oss.turingsenseai.com/1603512074441638739.png" />
      <span class="status-text">网络异常</span>
      <span class="status-link" @click='refreshing(true)'>重新加载</span>
    </div>
    <div v-if="pdList.length == 0" class="empty-err-page-container">
      <!-- 暂无数据 -->
      <img class="status-icon" src="https://oss.turingsenseai.com/1597910745455776183.png" />
      <span class="tips">很抱歉，没有找到符合条件的商品</span>
    </div>
    <van-pull-refresh v-if="errStatus == 0 && pdList.length > 0" v-model="refreshing" @refresh="getPdList(true)">
      <van-list
        v-model="loadingMore"
        :finished="finished"
        finished-text="没有更多了"
        @load="getPdList(false)">
        <div class="pd-list">
          <div class="pd-item" v-for="(pd, index) in pdList" :key="index" @click="goDetail(pd.pid)">
            <div class="pd-pic-container">
              <div class="pic-container">
                <img :src="pd.cover" />
              </div>
              <div class="grade">
                {{pd.newsName}}
              </div>
              <compute-time v-if="pd.seckillState==1" :secondTime="pd.seckillEndLeft"></compute-time>
            </div>
            <div class="brand">
                <span v-if="pd.isOfficial" class="officical-icon">自营</span>
              {{pd.brandEnName}}</div>
            <div class="brand-container">
              <span class="brand-name">{{pd.productName}}</span>
            </div>
            <div class="seckill-price">
              <span :class="`price ${pd.seckillState==1 ? 'seckill' : ''}`">￥{{pd.seckillState==1 ? pd.seckillPrice/100 : pd.actualPrice/100}}</span>
              <span v-if="pd.releasePrice && pd.releasePrice != 0" class="official-price">￥{{pd.releasePrice/100}}</span>
            </div>
            <div v-if="pd.relatedOaID" class="apprasial-label">
              <img class="a-icon" src="./../../../assets/images/ai-picture/apprasial-icon.png">
            </div>
            <div v-if="pd.seckillState==1" class="seckill-label">
              <img class="s-icon" src="./../../../assets/images/ai-picture/seckill-icon.png">
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- 弹出层 -->
    <van-popup v-model="showFilter" position="right">
      <div class="filter-pannel">
        <div class="price-container">
          <div class="title">价格</div>
          <div class="operate-container">
            <input type="number" placeholder="请输入" class="price-input" v-model="minPriceC"/>
            <span class="price-to">-</span>
            <input type="number" placeholder="请输入" class="price-input" v-model="maxPriceC" />
          </div>
        </div>
        <div class="split-line"></div>
        <div class="newdegree-container">
          <div class="title">成色</div>
          <div class="operate-container">
            <div :class="'newdegree-item ' + (degree.selected ? 'selected' : '')" v-for="(degree, index) in newDegreeList" :key="index" @click="changeDegreeSelect(index)">
              {{degree.name}}
            </div>
          </div>
        </div>
        <div class="split-line"></div>
        <div class="size-container">
          <div class="title">尺码</div>
          <div class="operate-container">
            <div :class="'size-item ' + (size.selected ? 'selected' : '')" v-for="(size, index) in sizeList" :key="index" @click="changeSizeSelected(index)">
              {{size.name}}
            </div>
          </div>
        </div>
        <div class="split-line"></div>
        <div class="color-container">
          <div class="title">颜色</div>
          <div class="operate-container">
            <div :class="'color-item ' + (color.selected ? 'selected' : '')" v-for="(color, index) in colorList" :key="index" @click="changeColorSelected(index)">
              <div class="color-item-inner" :style="`background-color:#${color.hexValue}`"></div>
            </div>
          </div>
        </div>
        <div class="button-container">
          <div class="cancel-btn" @click="reset">清空</div>
          <div class="confirm-btn" @click="filter">筛选</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { List, PullRefresh, Popup } from 'vant';
import { fetchColorList, fetchSizeList, fetchNewDegreeList, fetchMallProduct } from './../../../common/api/ai-picture.js';
import ComputeTime from './../components/compute-time';
// import {isTestEnv} from './../../common/constant'
import { H5PAGES_TARO_CONFIG } from './../../../common/navigate-config.js';

export default {
  components: {
    'van-list': List,
    'van-pull-refresh': PullRefresh,
    'van-popup': Popup,
    ComputeTime,
  },
  data () {
    return {
      refreshing: false,
      loadingMore: false,
      showFilter: false,
      finished: false,
      minPrice: '',
      maxPrice: '',
      pdList: [
        
      ],
      priceUpUrl: "https://oss.turingsenseai.com/1595988471276510660.png", // 向上箭头图片
      priceDownUrl: "https://oss.turingsenseai.com/1595988481608357495.png", // 向下箭头图片
      priceGreyUrl: "https://oss.turingsenseai.com/1595988430579925917.png", // 未选择当前图片

      colorList: [], // 颜色列表
      sizeList: [], // 尺寸列表
      newDegreeList: [], // 成色列表
      sortType: '-recommendation_score',

      pageNum: 0,
      skc: '',
      numList: [],
      errStatus: 0,
    }
  },
  computed: {
    minPriceC: {
      get: function () {
        return this.minPrice
      },
      set: function (val) {
        if (val.indexOf('.') > 0 && (val.length - val.indexOf('.')) > 3) {
          this.minPrice = ''
          this.minPrice = val.substr(0, val.length - 1)
        } else {
          this.minPrice = val;
        }

        if (val.indexOf('.') !== val.lastIndexOf('.')) {
          this.maxPrice = ''
          this.minPrice = val.substr(0, val.length - 1)
        }
      }
    },
    maxPriceC: {
      get: function () {
        return this.maxPrice
      },
      set: function (val) {
        if (val.indexOf('.') > 0 && (val.length - val.indexOf('.')) > 3) {
          this.maxPrice = ''
          this.maxPrice = val.substr(0, val.length - 1)
        } else {
          this.maxPrice = val
        }
        if (val.indexOf('.') !== val.lastIndexOf('.')) {
          this.maxPrice = ''
          this.maxPrice = val.substr(0, val.length - 1)
        }
      }
    }
  },
  methods: {
    changeFilterShow () {
      this.showFilter = true;
    },
    filter () {
      this.showFilter = false;
      this.getPdList(true);
    },
    // 查询商品列表
    getPdList (refresh = false) {
      this.errStatus = 0;
      if (refresh) {
        this.pageNum = 0;
      }
      this.pageNum++;
      const colorStr = this.colorList.filter(color => {
        return color.selected
      }).map(item => { return item.colorID }).join(',');
      const sizeStr = this.sizeList.filter(size => {
        return size.selected
      }).map(item => { return item.sizeID }).join(',');
      const newsStr = this.newDegreeList.filter(degree => {
        return degree.selected
      }).map(item => { return item.newsID }).join(',');
      const params = {
        pageNum: this.pageNum,
        pageSize: 10,
        skc: this.skc,
        sort: this.sortType,
        newsStr,
        sizeStr,
        colorStr
      }
      if (this.minPriceC) {
        params.actualMinPrice = this.minPriceC
      }
      if (this.maxPriceC) {
        params.actualMaxPrice = this.maxPriceC
      }
      console.log('hhhhhhhh')
      fetchMallProduct(params).then(result => {
        if (result && result.errorCode === 0) {
          this.refreshing = false;
          if (refresh) {
            this.pdList = result.searchInfo
          } else {
            this.pdList = [...this.pdList, ...result.searchInfo]
          }
          if (result.isEnd || result.searchInfo.length === 0) {
            this.finished = true;
          }
        }
      }, () => {
        this.errStatus = 1;
      }).finally(() => {
        this.refreshing = false;
        this.loadingMore = false;
      })
    },
    // 变更排序条件
    changeSortType (str) {
      if (str === '+actual_price') {
        this.sortType = this.sortType === str ? '-actual_price' : str
      } else {
        this.sortType = str;
      }
      this.getPdList(true);
    },
    changeDegreeSelect (index) {
      this.newDegreeList[index].selected = !this.newDegreeList[index].selected;
      this.newDegreeList = [...this.newDegreeList];
    },
    changeSizeSelected (index) {
      this.sizeList[index].selected = !this.sizeList[index].selected;
      this.sizeList = [...this.sizeList];
    },
    changeColorSelected (index) {
      this.colorList[index].selected = !this.colorList[index].selected;
      this.colorList = [...this.colorList];
    },
    reset () {
      this.colorList.forEach(item => { item.selected = false });
      this.sizeList.forEach(item => { item.selected = false });
      this.newDegreeList.forEach(item => { item.selected = false });
      this.maxPriceC = '';
      this.minPriceC = '';
      this.sizeList = [...this.sizeList];
      this.colorList = [...this.colorList];
      this.newDegreeList = [...this.newDegreeList];
    },
    goDetail (pid) {
      if (window.isWXWebView) {
        wx.miniProgram.navigateTo({ url: `/pages/choice/detail?pid=${pid}` });
      } else {
        // H5PAGES_TARO_CONFIG.toProductDetail(pid)
        // window.location.href = isTestEnv ? `https://baoh5test.turingsenseai.com/h5/#/pages/choice/detail?pid=${pid}` : `https://baoh5.turingsenseai.com/h5/#/pages/choice/detail?pid=${pid}`
      }
    }
  },
  watch () {
    this.skc = this.$route.query.skc;
    this.getPdList(true);
    fetchColorList({ kindID: 83 })
    .then(result => {
      if (result && result.errorCode === 0) {
        this.colorList = result.colorList;
      }
    });
    fetchSizeList({ kindID: 83 })
    .then(result => {
      if (result && result.errorCode === 0) {
        this.sizeList = result.sizeList;
      }
    });
    fetchNewDegreeList({ kindID: 83 })
    .then(result => {
      if (result && result.errorCode === 0) {
        this.newDegreeList = result.news;
      }
    });
  },
  mounted () {
    this.skc = this.$route.query.skc;
    this.getPdList(true);
    fetchColorList({ kindID: 83 })
    .then(result => {
      if (result && result.errorCode === 0) {
        this.colorList = result.colorList;
      }
    });
    fetchSizeList({ kindID: 83 })
    .then(result => {
      if (result && result.errorCode === 0) {
        this.sizeList = result.sizeList;
      }
    });
    fetchNewDegreeList({ kindID: 83 })
    .then(result => {
      if (result && result.errorCode === 0) {
        this.newDegreeList = result.news;
      }
    });
  }
}
</script>
